import { Table } from 'antd';
import 'antd/dist/antd.min.css';
import React, { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { getFormattedDate } from '../utils';
import ItemManageButton from './ItemManageButton';
import UserRewardCard from './UserRewardCard';
import { WITHDRAWAL_REWARD_STATUS_CODE } from '../constant';

function onChange(pagination, filters, sorter, extra) {
  // console.log('params', pagination, filters, sorter, extra);
}

function UserRewardInputTable(props) {
  const [userRewardList, setUserRewardList] = useState(props.userRewardList);

  useEffect(() => {
    setUserRewardList(props.userRewardList);
  }, [props.userRewardList]);

  const handleUpdateSuccess = (record) => {
    props.handleClickRefresh();
    // setUserRewardList(userRewardList.filter((item) => item !== record));
  };

  // profilePicUrl lastLogonDate
  const columns = [
    {
      title: '아이디',
      dataIndex: 'user',
      render: (record) => <span>{record?.name}</span>,
    },
    {
      title: '이메일',
      dataIndex: 'user',
      render: (record) => <span>{record?.email}</span>,
    },
    {
      title: '로그인 유형',
      dataIndex: 'user',
      render: (record) => <span>{record?.authType}</span>,
    },
    {
      title: '국가',
      dataIndex: 'user',
      render: (record) => <span>{record?.countryCode}</span>,
    },
    {
      title: '프로필 이미지',
      dataIndex: 'user',
      render: (record) => (
        <span>
          {record?.profilePicUrl ? (
            <a
              href={record.profilePicUrl}
              target="_blank"
              rel="noreferrer"
              className="mr-4"
            >
              새 창에서 보기
            </a>
          ) : null}
        </span>
      ),
    },
    {
      title: '인스타그램',
      dataIndex: 'user',
      render: (record) => (
        <span>
          {record?.instagramId ? (
            <a
              href={`https://instagram.com/${record?.instagramId}`}
              target="_blank"
              rel="noreferrer"
              className="mr-4"
            >
              {record?.instagramId}
            </a>
          ) : null}
        </span>
      ),
    },
    {
      title: '입금일',
      dataIndex: 'createdAt',
      sorter: {
        compare: (a, b) => {
          const createdAtA = dayjs(a.createdAt);
          const createdAtB = dayjs(b.createdAt);

          return createdAtA.diff(createdAtB);
        },
        multiple: 2,
      },
      render: (createdAt) => <span>{getFormattedDate(createdAt)}</span>,
    },
    {
      title: '입금금액',
      dataIndex: 'transactionReward',
      sorter: {
        compare: (a, b) => a.transactionReward - b.transactionReward,
        multiple: 1,
      },
    },
  ];

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys, item) => {
    console.log('선택된 행 키: ', newSelectedRowKeys, item);

    setSelectedRowKeys(newSelectedRowKeys);
    props.setSelectedRows(item);

    props.setIsAvailableFinish(
      item.filter(
        (row) => row.status === WITHDRAWAL_REWARD_STATUS_CODE.ACCEPTED.key,
      ).length > 0 &&
        item.filter(
          (row) => row.status === WITHDRAWAL_REWARD_STATUS_CODE.REQUESTED.key,
        ).length < 1,
    );
    props.setIsAvailableAccept(
      item.filter(
        (row) => row.status === WITHDRAWAL_REWARD_STATUS_CODE.REQUESTED.key,
      ).length > 0 &&
        item.filter(
          (row) => row.status === WITHDRAWAL_REWARD_STATUS_CODE.ACCEPTED.key,
        ).length < 1,
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
    // 특정 셀의 선택을 비활성화하기 위한 조건 설정
    getCheckboxProps: (record) => ({
      disabled:
        record.status === WITHDRAWAL_REWARD_STATUS_CODE.REJECTED.key ||
        record.status === WITHDRAWAL_REWARD_STATUS_CODE.FINISHED.key ||
        !record.userId,
      name: record.name,
    }),
  };

  return (
    <Table
      columns={columns}
      dataSource={userRewardList}
      rowKey={(record) => record._id}
      // expandable={{
      //   expandedRowRender: (record) => (
      //     <UserRewardCard
      //       userData={record}
      //       handleClickRefresh={props.handleClickRefresh}
      //     />
      //   ),
      //   rowExpandable: (record) => true,
      // }}
      // rowSelection={rowSelection}
      onChange={onChange}
    />
  );
}

export default UserRewardInputTable;
